import FeatureContainer from './featureContainer'

export default FeatureContainer
